import React from 'react';
import cc from 'classcat';
import styles from './breadCrumbs.module.sass';
import { Icon } from '../Icon';
import { IconSVG } from '../SpriteSVG';

export const BreadCrumbs = ({ routeCrumbs, url }) => (
  <div
    className={styles.wrapper}
    itemScope
    itemType="https://schema.org/BreadcrumbList"
  >
    <div className={styles.overflowWrapper}>
      <a className={styles.crumb} href={'/'}>
        <span
          itemProp="name"
          className={cc([
            styles.home,
            {
              [styles.homeBf]: url === 'black_friday',
            },
          ])}
        >
          {url === 'black_friday' ? (
            <Icon
              icon={
                <IconSVG name={'common/bfHomePage'} width={10} height={10} />
              }
              itemProp="item"
            />
          ) : (
            <Icon
              icon={<IconSVG name={'common/HomePage'} width={16} height={16} />}
              itemProp="item"
            />
          )}
        </span>
      </a>
      {routeCrumbs.map((i, id) => (
        <li
          itemProp="itemListElement"
          itemScope
          itemType="https://schema.org/ListItem"
          className={styles.point}
          key={id}
        >
          {url === 'black_friday' ? (
            <a itemProp="item" href={i.link} className={styles.crumb}>
              <span
                itemProp="name"
                className={
                  id === routeCrumbs.length - 1
                    ? styles.currentBf
                    : styles.activeBf
                }
              >
                {i.title}
              </span>
              <meta itemProp="position" content={id + 1} />
            </a>
          ) : (
            <a itemProp="item" href={i.link} className={styles.crumb}>
              <span
                itemProp="name"
                className={
                  id === routeCrumbs.length - 1 ? styles.current : styles.active
                }
              >
                {i.title}
              </span>
              <meta itemProp="position" content={id + 1} />
            </a>
          )}
        </li>
      ))}
    </div>
  </div>
);
